import { useState, useEffect } from 'react';
import validateFormInputs from './form-inputs-validators/inputsForms';
import { regiones, communesByReg } from 'happ-services/profile/profile-services';
import moment from 'moment';

const useValidatorFrom = (initialState, fn) => {
    const [state, setState] = useState(initialState);
    const [errors, setErrors] = useState({});
    const [submit, setSubmit] = useState(false);
    const [comunes, setComunes] = useState(null);
    const [stateReg, setStateReg] = useState(null);

    const {region} = state;

    useEffect(() => {
        if (submit) {
            if ( !Object.keys(errors).length ){
                fn();
            }
            setSubmit(false);
        }
    }, [errors, submit, fn]);

    useEffect(() => {
        if (region) {
            const comunes = communesByReg(region);
            setComunes(comunes);
        } else {
            setComunes(null);
        }
    }, [region])

    useEffect(() => {
        setStateReg(regiones);
    }, []);
    
    
    const handlerChange = e => {
        setState({
            ...state,
            [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value
        });
    }

    const handlerChangeReg = e => {
        const comunes = communesByReg(e.target.value);
        setComunes(comunes);
        setState({
            ...state,
            region: e.target.value, 
            commune: ''
        });     
    }

    const handlerDateChange = date => {
        console.log(date);
        const dateFormat = moment(date).format('YYYY-MM-DD');
        setState({
            ...state,
            birthday: dateFormat
        });
    }
    
    const handlerSubmit = e => {
        e.preventDefault();
        const arrayErrors = validateFormInputs(state);
        setErrors(arrayErrors);
        setSubmit(true);
    }
    
    return {
        state, 
        comunes,
        stateReg,
        errors,
        handlerChange, 
        handlerSubmit,
        handlerDateChange,
        handlerChangeReg
    }
}
export default useValidatorFrom;